// src/hooks/useCrearEnvio.js
import { useState, useCallback } from 'react';
import { crearEnvio } from '../services/enviosService';

export function useCrearEnvio(handleError) {
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  const createEnvio = useCallback(
    async (payload, onSuccess, onReset) => {
      try {
        setLoadingCreate(true);
        setMensaje(null);

        // Validación de peso
        if (!payload?.pesoLibras || Number(payload.pesoLibras) <= 0) {
          throw new Error('Debe ingresar un peso válido en libras');
        }

        const res = await crearEnvio(payload);

        // ✅ aceptar id dentro de envio o en envioId
        const id = res?.envio?.id || res?.envioId;
        if (!id) {
          throw new Error(res?.mensaje || 'El backend no devolvió un identificador de envío');
        }

        // Normalizamos el envío con id garantizado
        const envioNormalizado = { ...res.envio, id };

        setMensaje(res.mensaje || '✅ Envío creado con éxito');

        if (onSuccess) onSuccess(envioNormalizado);
        if (onReset) onReset();

        return envioNormalizado;
      } catch (err) {
        setMensaje(err.message || err?.detalle || '❌ Error al crear envío');
        if (handleError) handleError(err, '❌ Error al crear envío');
        return null;
      } finally {
        setLoadingCreate(false);
      }
    },
    [handleError]
  );

  return { loadingCreate, createEnvio, mensaje };
}